module.exports = __webpack_public_path__ + "img/18-27-170.fbae3199.jpg";